import { permissions } from '@mpk/shared/domain';

enum DocumentManagementSapSettingsPermissionsEnum {
  None = 0,

  /**
   * SAP-Einstellungen der Organisation bearbeiten.
   */
  ManageSapSettings = 1,
}

export const DocumentManagementSapSettingsPermissions = permissions(DocumentManagementSapSettingsPermissionsEnum, {
  featureId: 'SapSettings',
});
